import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DownArrow from '../Svg/DownArrow';
import { isPortrait } from '../../utils/size';
import { copyFor } from '../../copy/copy';

const BackButtonContainer = styled.div`
    display: flex;
    position: relative;
    flex-direction: row;
    align-items: center;
    width: ${props => (props.newsletterSignUpVisible ? `auto` : `60px`)};
    cursor: pointer;

    span {
        z-index: -1;
        position: absolute;
        font-size: 10px;
        color: #008eff;
        font-weight: normal;
        padding: 0;
        bottom: 2.5px;
        left: ${props => (!props.isPortrait ? `-15px` : `26px`)};
        display: ${() => (isPortrait() ? `none` : `block`)};
        transition: left 500ms ease;
    }
    ${props =>
        !props.isPortrait &&
        `
            &:hover {
                span {
                    transition: left 500ms ease;
                    left: 26px;
                }
            }
    `}
`;

const Button = styled.button`
    height: 20px;
    width: 21px;
    border-radius: 11px;
    background: #fff;
    border: 1px solid #008eff;
    cursor: pointer;
    outline: none;

    svg {
        fill: #008eff;
        position: absolute;
        top: 2.5px;
        left: 3px;
        transform: rotate(90deg);
    }

    ${props =>
        !props.isPortrait &&
        `
            &:hover {
                transition: color 250ms ease;
                background: #008eff;
                svg {
                    transition: fill 250ms ease;
                    fill: #fff;
                }
            }
        `};
`;

const BackButton = props => (
    <BackButtonContainer
        onClick={e => props.onClick(e)}
        isPortrait={isPortrait()}
        newsletterSignUpVisible={props.newsletterSignUpVisible}
    >
        <Button isPortrait={isPortrait()}>
            <DownArrow width={15} height={15} />
        </Button>
        <span>{copyFor('footer', 'back', null, 'all')}</span>
    </BackButtonContainer>
);

BackButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    newsletterSignUpVisible: PropTypes.bool
};

export default BackButton;
